import { merge } from 'lodash';
import { TLeadFormSubmitSchedulerData } from '~/components/ClientExperience/OneFlow/components/FlowView/LeadFormSubmit/LeadFormSubmit.types';
import { PaymentMethodType } from '~/types/pay.types';
import { PaymentMethod } from '@stripe/stripe-js';
import { PublicFlowCxService } from '~/components/ClientExperience/OneFlow/services/public-flow-cx.service';

export class LeadFormCxService extends PublicFlowCxService {
    async submitLeadForm({
        data,
        recaptchaData,
        email,
        flowId,
        fullName,
        revisionId,
        scheduleData,
        gratuity,
        forterToken,
        hasInvoiceBlock,
        sms_consent_text_version,
        leadPhoneNumber,
        time_zone_offset,
        stripePaymentMethod
    }: {
        data: Record<string, any>;
        recaptchaData: object;
        email: string;
        flowId: string;
        fullName: string;
        revisionId: string;
        scheduleData?: TLeadFormSubmitSchedulerData;
        gratuity?: number;
        stripePaymentMethod?: PaymentMethod;
        forterToken?: string;
        hasInvoiceBlock?: boolean;
        sms_consent_text_version?: number;
        leadPhoneNumber?: string;
        time_zone_offset?: number;
    }) {
        const company_id = this.clientPortalConfigStore?.clientPortalCompanyId;

        const transformedData = this.transformFlowRequest(data);

        let payment_data = null;

        if (hasInvoiceBlock) {
            const pay_data = {
                payment_tip: gratuity,
                paid_in_person: false,
                activate_auto_payment: false,
                activate_recurring_payment: false,
                forter_token: forterToken
            };

            const payment_method_data = {
                ...stripePaymentMethod?.card,
                token_id: stripePaymentMethod?.id,
                primary_source: 'payment_element',
                secondary_source:
                    stripePaymentMethod?.card?.wallet?.type || 'manual',
                _type: PaymentMethodType.CreditCard,
                card_role: null // unnecessary?
            };

            // PaymentElement only
            if (stripePaymentMethod) {
                const {
                    billing_details: {
                        address: {
                            city: address_city,
                            country: address_country,
                            line1: address_line1,
                            line2: address_line2,
                            postal_code: address_zip,
                            state: address_state
                        }
                    }
                } = stripePaymentMethod;

                merge(payment_method_data, {
                    address_line1,
                    address_line2,
                    address_city,
                    address_zip,
                    address_state,
                    address_country
                });
            }

            payment_data = {
                pay_data,
                payment_method_data
            };
        }

        return super._submitLeadForm({
            flowId,
            transformedData,
            email,
            company_id,
            fullName,
            revisionId,
            scheduleData,
            payment_data,
            recaptchaData,
            sms_consent_text_version,
            leadPhoneNumber,
            time_zone_offset
        });
    }
}
